export const COOKIE_GROUPS = {
  StrictlyNecessaryCookies: 'C0001',
  PerformanceCookies: 'C0002',
  FunctionalCookies: 'C0003',
  TargetingCookies: 'C0004',
  SocialMediaCookies: 'C0005',
};

export const AI_COOKIES = ['ai_session', 'ai_user'];
